import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import Icon from 'utils/components/icon';
import classnames from 'classnames';
import User from '../../../models/user';
import TeammateControls from './teammate-controls';
import BlacklistControls from './blacklist-controls';
import WhitelistControls from './whitelist-controls';

class UserItem extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    className: PropTypes.string,
    spotId: PropTypes.string,
    teammtes: PropTypes.array,
    currentUserId: PropTypes.string,
    spot: PropTypes.object,
    type: PropTypes.string,
    lastElement: PropTypes.bool,
    addUser: PropTypes.func,
    removeUser: PropTypes.func,
    isViewOnlyMode: PropTypes.bool,
    userControls: PropTypes.object
  };

  static displayName = 'UserItem';

  constructor(props, context) {
    super(props, context);
    this.state = { isPhoneNumberVisible: false };
  }

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  @autobind
  showPhoneNumber() {
    this.setState({ isPhoneNumberVisible: true });
  }

  @autobind
  renderOptions(user) {
    const {
      type,
      isViewOnlyMode,
      spot,
      currentUserId,
      lastElement,
      addUser,
      removeUser,
      userControls
    } = this.props;
    let { id: spotId } = spot;

    if (isViewOnlyMode) {
      return null;
    }

    let isCurrentUser = currentUserId === user.id;
    let userId = user.id || user.userId;

    if (userControls) {
      const UserControls = userControls;
      return <UserControls user={user} />;
    }

    switch (type) {
      case 'teammates':
        return (
          <TeammateControls
            user={user}
            spotId={spotId}
            lastElement={lastElement}
            isCurrentUser={isCurrentUser}
            addRole={addUser}
            removeRole={removeUser}
          />
        );
      case 'blacklist':
        return (
          <BlacklistControls
            user={user}
            spotId={spot.id}
            addUser={addUser}
            removeUser={removeUser}
          />
        );

      case 'whitelist':
        return (
          <WhitelistControls
            user={user}
            userId={userId}
            spotId={spot.id}
            addUser={addUser}
            removeUser={removeUser}
          />
        );
    }
  }

  render() {
    let { user, type, spot, currentUserId, lastElement, addUser, removeUser } = this.props;
    let { isPhoneNumberVisible } = this.state;
    let { id: spotId, isRequiredTwoStepVerification } = spot;
    let userId = user.id || user.userId;
    user = new User().parse(user);
    let { username, displayName, email } = user;
    if (!user.isRegistered) {
      username = null;
      displayName = (
        <div className="display-name">
          {'Guest'}
          <span className="user-id"> {`(${user.id})`}</span>
        </div>
      );
    } else if (displayName) {
      displayName = <div className="display-name">{displayName}</div>;
    }

    let phoneNumber = undefined; // it looks like it is always undefined anyway, left for consistency
    let icon = null,
      thumbnailUrl;
    let props = {
      className: classnames('user-image', 'small-user-image')
    };

    if (user.isGuestAvatar()) {
      let isDefaultImage = user.isDefaultImage();
      props.className = classnames(props.className, 'avatar-' + user.getGuestColor(), {
        'avatar-default': isDefaultImage
      });
      icon = <Icon name={user.getGuestIcon()} />;
    } else {
      thumbnailUrl = user.getThumbnailUrl({ width: 24, height: 24 });
      props.style = { backgroundImage: 'url(' + thumbnailUrl + ')' };
    }

    return (
      <div className="user-item">
        <div className="user-image-wrapper">
          <div {...props}>{icon}</div>
        </div>
        <div className="user-deatils">
          {displayName}
          {username ? <div className="username">{`@${username}`}</div> : null}
          {email ? <div className="username">{email}</div> : null}
          {isRequiredTwoStepVerification && phoneNumber && (
            <div className="verified-link">
              <span className="verified-text">Verified</span>
              <span className="show-number middle-dot-before" onClick={this.showPhoneNumber}>
                <span className="phone">{isPhoneNumberVisible ? phoneNumber : '[Show]'}</span>
              </span>
            </div>
          )}
        </div>
        {this.renderOptions(user)}
      </div>
    );
  }
}

export default UserItem;
